"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractIntsFromStr = exports.filterNaInt = exports.filterNaN = exports.fixedFloat = void 0;

// given a number, checks if float. If so, truncates to given decimal count
var fixedFloat = function fixedFloat(rawNumber, fixCount) {
  // check if the rawNumber is an integer
  // if so, just return the intege
  if (rawNumber % 1 === 0) return "".concat(rawNumber); // otherwise apply toFixed and return
  else return rawNumber.toFixed(fixCount);
}; // tests a given string to see if it is a valid number
// returns the string if valid, returns empty string if not


exports.fixedFloat = fixedFloat;

var filterNaN = function filterNaN(value) {
  var float = parseFloat(value);
  if (isNaN(float)) return "";else if (value[value.length - 1] === ".") return "".concat(float, ".");else return "".concat(float);
}; // tests a given string to see if it is a valid integer
// returns the string if valid, returns empty string if not


exports.filterNaN = filterNaN;

var filterNaInt = function filterNaInt(value) {
  var float = parseFloat(value);
  if (isNaN(float)) return "";else if (float % 1 !== 0) return "";else return "".concat(float);
}; // given a string which possibly contains integers,
// returns an array of all integers matching regEx


exports.filterNaInt = filterNaInt;

var extractIntsFromStr = function extractIntsFromStr(str) {
  var regEx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\d+/g;
  var intArray = []; // finds all the matching sub-strs

  var matchArray = str.match(regEx); // if any matches were found...

  if (matchArray) matchArray.forEach(function (match) {
    // ...parse the int and push to return
    intArray.push(parseInt(match));
  });
  return intArray;
};

exports.extractIntsFromStr = extractIntsFromStr;